import { format, formatISO, isValid, parseISO } from 'date-fns';

/*
 * dateFormat に合わない入力は react-datepicker が new Date() にフォールバックするため、
 * "20261/10/01" のような打ちかけの値でも 20261 年の Date が onChange に届く。
 * 5 桁年は yyyy-MM-dd に収まらず、次の描画の parseISO が Invalid Date になって
 * DatePicker が落ちるので、4 桁年に収まる日付だけを扱う。
 */
export const isSupportedDate = (date: Date) =>
  isValid(date) && date.getFullYear() >= 1000 && date.getFullYear() <= 9999;

/** DatePicker の selected などに渡すための yyyy-MM-dd のパース。空や扱えない値は null */
export const parseSupportedDate = (value?: string | null): Date | null => {
  if (!value) return null;
  const date = parseISO(value);
  return isSupportedDate(date) ? date : null;
};

/**
 * APIから返るISO日時文字列(UTC)をシステムローカルタイムの日付として整形する
 */
export const formatYMD = (value?: string | null, emptyValue = '-', formatStr = 'yyyy-MM-dd') => {
  if (!value) {
    return emptyValue;
  }
  const parsedDate = parseISO(value);
  if (!isValid(parsedDate)) {
    return emptyValue;
  }
  return format(parsedDate, formatStr);
};

/**
 * 日付文字列(YYYY-MM-DD)とローカル時刻をISO形式に変換
 * ローカルタイムゾーンのオフセット付きISO形式（例: 2026-06-10T00:00:00+09:00）で返される
 * APIへの送信時に使用（DateTimeFieldとの互換性のため）
 */
export const convertDateTimeToLocalISO = (
  dateString?: string,
  hour?: number,
  min?: number,
  sec?: number,
): string => {
  if (!dateString) return '';

  const dateHour = hour ?? 0;
  const dateMin = min ?? 0;
  const dateSec = sec ?? 0;

  // YYYY-MM-DD形式の文字列をDateオブジェクトに変換
  const date = parseISO(dateString);

  if (!isValid(date)) {
    return '';
  }

  // ローカルタイムとして日時を構築（タイムゾーンを考慮してUTCに変換される）
  const localDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    dateHour,
    dateMin,
    dateSec,
    0,
  );

  // formatISOはローカルタイムをISO形式に変換
  return formatISO(localDate);
};
